import { Button } from '@mui/material';
import { useReaderConfiguration } from './ReaderConfigurationContext';
import { t } from 'i18next';

export default function ResetReaderConfigurationButton() {
  const { resetTheme } = useReaderConfiguration();

  return (
    <Button
      variant='outlined'
      size='large'
      sx={{ textTransform: 'none' }}
      onClick={() => resetTheme()}
    >
      {t('readerConfiguration.reset')}
    </Button>
  );
}
